<template>
  <div>
    <div class="my-3">
      <button class="btn btn-link pl-0" @click="back">
        <i class="fas fa-angle-left"></i> Back to Summary
      </button>
    </div>

    <!-- filters -->
    <InsightsDetailsFilters class="mb-4" @filtersApplied="refreshDetails" :key="refreshKey" />

    <!-- details -->
    <InsightsDetails :loading="loading" :wcLoading="wcLoading" @refreshDetails="refreshKey++" />
  </div>
</template>

<script>
import InsightsDetailsFilters from './InsightsDetailsFilters'
import InsightsDetails from './InsightsDetails'
import { createNamespacedHelpers } from 'vuex'

const InsightsDetailsModule = createNamespacedHelpers('insightsDetails')
const InsightsModule = createNamespacedHelpers('insights')

export default {
  name: 'DetailsView',
  components: {
    InsightsDetailsFilters,
    InsightsDetails
  },
  data: () => ({
    loading: true,
    wcLoading: true,
    refreshKey: 0
  }),
  mounted() {
    window.scrollTo(0, 0)
  },
  computed: {
    ...InsightsModule.mapGetters(['selectLastSummaryURL'])
  },
  methods: {
    ...InsightsDetailsModule.mapActions([
      'fetchPopulatedClassifications',
      'fetchClassifications',
      'fetchFeedbackCount',
      'fetchFeedbackCountBreakdown',
      'fetchOppositeSentimentClassifications',
      'fetchSummaries'
    ]),
    back() {
      this.$router.push(this.selectLastSummaryURL)
    },
    refreshDetails() {
      this.loadBasic()
      this.loadSummaries()
    },
    async loadBasic() {
      this.loading = true
      await Promise.all([
        this.fetchPopulatedClassifications(),
        this.fetchClassifications(),
        this.fetchOppositeSentimentClassifications(),
        this.fetchFeedbackCount(),
        this.fetchFeedbackCountBreakdown()
      ])
      this.loading = false
    },
    async loadSummaries() {
      this.wcLoading = true
      await this.fetchSummaries()
      this.wcLoading = false
    }
  }
}
</script>
